import HorDefault from './HorDefault';
import {NavStyle} from '../../../shared/constants/AppEnums';

const Layouts = {
  [NavStyle.H_DEFAULT]: HorDefault,
};
export default Layouts;
